// extracted by mini-css-extract-plugin
export const container = "hero-module--container--3PTu0";
export const tint = "hero-module--tint--17-yO";
export const imageContainer = "hero-module--imageContainer--lZVHK";
export const image = "hero-module--image--3EwX_";
export const title = "hero-module--title--1vq51";
export const video = "hero-module--video--2Rnrr";
export const canPlay = "hero-module--canPlay--lhB5W";
export const arrow = "hero-module--arrow--vxT2l";